import {
  AlertNotificationModel,
  AlertNotificationPayload,
  AlertNotificationProjectUserModel,
  AlertNotificationProjectUserPayload,
  AlertNotificationUserListDataModel,
  AlertNotificationUserListDataPayload,
  AlertNotificationUserListResponseModel,
  AlertNotificationUserListResponsePayload,
  AlertNotificationUserModel,
  AlertNotificationUserPayload,
} from '../models';

const alertNotificationUserToPayload = (payload: AlertNotificationUserModel): AlertNotificationUserPayload => {
  const { id } = payload;

  return { id };
};

export const alertNotificationToPayload = (payload: AlertNotificationModel): AlertNotificationPayload => {
  const { deviceUuid, enabled, userList } = payload;

  const transformedUserList = !!userList.length ? userList.map((item) => alertNotificationUserToPayload(item)) : [];

  return {
    enabled,
    device_uuid: deviceUuid,
    user_list: transformedUserList,
  };
};

const payloadToAlertNotificationUserListUser = (payload: AlertNotificationProjectUserPayload): AlertNotificationProjectUserModel => {
  const { email, id, username, roles } = payload;

  return {
    email: email ?? '',
    id: id ?? '',
    username: username ?? '',
    roles: roles ?? [],
  };
};

const payloadToAlertNotificationUserListData = (payload: AlertNotificationUserListDataPayload): AlertNotificationUserListDataModel => {
  const { user_list } = payload;

  const transformedUserList = user_list.map((item) => payloadToAlertNotificationUserListUser(item)) ?? [];

  return {
    userList: transformedUserList,
  };
};

export const payloadToAlertNotificationUserList = (
  payload: AlertNotificationUserListResponsePayload
): AlertNotificationUserListResponseModel => {
  const { data } = payload;

  const transformedData = payloadToAlertNotificationUserListData(data);

  return {
    data: transformedData,
  };
};
